import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKodemLogo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 46 46",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M0.143555 8.51002C0.143555 3.88895 3.88967 0.142822 8.51074 0.142822H37.4906C42.1117 0.142822 45.8578 3.88894 45.8578 8.51001V37.4899C45.8578 42.111 42.1117 45.8571 37.4907 45.8571H8.51075C3.88968 45.8571 0.143555 42.111 0.143555 37.4899V8.51002Z",
			fill: "url(#paint0_linear_1602_12029)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.5739 9.45508H28.3636L19.9421 22.6446L28.3636 35.8342H35.5739L27.148 22.6446L35.5739 9.45508Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.5603 9.48584H11.1479V35.8341H17.5603V9.48584Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_1602_12029",
			x1: 5.6462,
			y1: 11.5714,
			x2: 39.9319,
			y2: 31.8889,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .100856,
				stopColor: "#FF6868"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#FEB45E"
			})]
		}) })
	]
});
const ForwardRef = forwardRef(SvgKodemLogo);
export { ForwardRef as ReactComponent };
